import gql from 'graphql-tag';

export const UPDATE_LOOK_SIMPLE_FIELD_FILTER = gql`
  mutation updateLookSimpleFieldFilter($filter: SimpleFieldFilterInput!, $orderBy: [String]) {
    updateLookSimpleFieldFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
